import { isProd } from "../env";

const log = async (
  severity: string,
  message: string,
  extras: object,
): Promise<void> => {
  await fetch("/post/log/web", {
    method: "POST",
    credentials: "same-origin",
    body: JSON.stringify({
      severity,
      message,
      sourceApplication: "innlogging",
      extras,
    }),
    headers: {
      Accept: "application/vnd.digipost-v2+json",
      "Content-Type": "application/vnd.digipost-v2+json",
    },
  });
};

const unknownErrorMessage = "Received unknown error.";

export const logError = async (
  error: Error | unknown,
  extras = {},
): Promise<void> => {
  if (!isProd) {
    if (error instanceof Error) {
      console.error(error, extras);
    } else {
      console.error(unknownErrorMessage, { ...extras, error });
    }
  }

  if (error instanceof Error) {
    log("ERROR", error.message, {
      ...extras,
      stack: error.stack,
    });
  } else {
    log("ERROR", unknownErrorMessage, { ...extras, error });
  }
};

export const logReactError = (
  error: Error,
  info: object,
  boundary: string,
): Promise<void> =>
  logError(error, {
    reactInfo: info,
    boundary,
  });
